import axios from 'axios';
import { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../ContextAuth/Context';
import OpenandCloseModal from './OpenandCloseModal';
import { MdAccountCircle } from 'react-icons/md';
import { LiaStarSolid } from 'react-icons/lia';
import {
  formatAmount,
  formatDateStrToDate,
  formatRating,
  getToken,
} from '../utils';

function SellOfferData() {
  const [sellOfferData, setSellOfferData] = useState([]);

  const { token: userToken } = getToken();

  const {
    handleOpenandCloseModal,
    setOfferDetails,
    offerDetails,
    setCxId,
    cxId,
    openModal,
  } = OpenandCloseModal();

  useEffect(() => {
    const getsellOffers = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/cx-transaction/specific-cxs`,
          {
            transaction_type_id: 2,
            transaction_status_id: 1,
          },
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );

        setSellOfferData(response?.data);
      } catch (error) {
        console.log(error);
      }
    };
    getsellOffers();
  }, [userToken]);

  const sellOfferDataArray = sellOfferData?.map((sellOffers) => {
    return {
      date: `${formatDateStrToDate(sellOffers?.created_at)}`,
      buyer_seller: (
        <div className='flex flex-row items-start gap-2'>
          <span className='text-4xl text-b-mc/70'>
            <MdAccountCircle />
          </span>
          <div className='flex flex-col justify-start text-left'>
            <p>{sellOffers?.unique_code}</p>
            <div className='flex flex-col gap- text-sm'>
              <p className='flex flex-row items-center gap-1 text-s-bk'>
                Rating: {formatRating(sellOffers?.user?.rating)}{' '}
                <span className='text-green-500 -m-1'>
                  <LiaStarSolid />
                </span>
              </p>{' '}
              {/* <p className="flex flex-row items-center gap-1 text-s-bk">
              Order: {data?.user.trx_stats?.completed}{" "}
              <span className="text-green-500 -m-1">{<BiTransfer />}</span>
            </p> */}
            </div>
          </div>
        </div>
      ),
      // currency: (
      //   <div className="flex flex-row items-center gap-2 justify-center">
      //     <img
      //       className="w-5 h-[13px]"
      //       src={sellOffers?.quote_currency?.country.flag}
      //       alt="currency flag"
      //     />
      //     <p>{sellOffers?.quote_currency.name}</p>
      //   </div>
      // ),
      amount: (
        <div className='flex flex-row items-center gap-2 justify-center'>
          <img
            className='w-5 h-[13px]'
            src={sellOffers?.quote_currency?.country?.flag}
            alt='currency flag'
          />
          <p>{`${formatAmount(sellOffers?.amount * 1)}  ${
            sellOffers?.quote_currency?.symbol
          }`}</p>
        </div>
      ),
      rate: ` ${formatAmount(sellOffers?.rate)}  ${
        sellOffers?.base_currency.symbol
      }`,
      payment: sellOffers?.transaction_method?.name,
      action: (
        <button
          className='text-p-wh px-4 py-1.5 rounded text-[10px] w-fit active:bg-t-bk hover:bg-red-600 bg-red-500'
          onClick={() => getCLickedRowId(sellOffers?.id)}
        >
          See details
        </button>
      ),
    };
  });

  const getCLickedRowId = (ids) => {
    setCxId(ids);
    for (let i = 0; i < sellOfferData.length; i++) {
      if (sellOfferData[i].id === ids) {
        setOfferDetails(sellOfferData[i]);
        handleOpenandCloseModal('offerdetails');
      }
    }
  };
  return {
    sellOfferDataArray,
    handleOpenandCloseModal,
    offerDetails,
    cxId,
    openModal,
  };
}

export default SellOfferData;
